import { TRepProps } from './Rep.types'

export const useRepLogic = (props: TRepProps) => {
  const { rep, onNotifySurgeryToRep } = props

  const handleCheckboxChange = (
    type: 'notifyEmail' | 'notifySms',
    checked: boolean
  ) => {
    onNotifySurgeryToRep(rep.auth0Id, checked, type)
  }

  return {
    handleCheckboxChange,
  }
}
